var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-150"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M467,443.86a16.66,16.66,0,0,1,24.72,12.82c-10.1,0-20-2.35-24.72-12.82",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.76,433.51a21.55,21.55,0,0,0,28.18-22.46c-12.83,2.52-24.87,8-28.18,22.46",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.79,450.6a3.91,3.91,0,0,1,.63-.25l1.85-.62c1.6-.52,3.92-1.28,6.77-2.27,5.71-2,13.54-4.84,22-8.51,4.21-1.85,8.17-3.73,11.73-5.53s6.67-3.58,9.25-5.15a62.35,62.35,0,0,0,5.87-4c1.32-1,2-1.71,2-1.67a3,3,0,0,1-.45.5,17.63,17.63,0,0,1-1.43,1.33,53.27,53.27,0,0,1-5.81,4.19c-2.55,1.62-5.68,3.4-9.22,5.26s-7.52,3.73-11.75,5.59c-8.45,3.68-16.32,6.5-22.06,8.38-2.87.95-5.21,1.65-6.83,2.11l-1.87.53A2.71,2.71,0,0,1,434.79,450.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480,449.74c0,.08-1.22-.74-3.23-1.83a40.35,40.35,0,0,0-8.27-3.32,39.52,39.52,0,0,0-8.82-1.35c-2.28-.09-3.71,0-3.71-.08a4,4,0,0,1,1-.16,23.46,23.46,0,0,1,2.73-.13,34.47,34.47,0,0,1,17.26,4.72,23,23,0,0,1,2.28,1.51A3.41,3.41,0,0,1,480,449.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.73,404.78a21,21,0,0,0,20.7,28.35c-1.92-12.58-6.76-24.54-20.7-28.35",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.76,398.6c.08,0,.42,1.38,1.15,3.57a53.5,53.5,0,0,0,3.55,8.28,54.61,54.61,0,0,0,4.93,7.54c1.43,1.82,2.4,2.88,2.34,2.94a3.93,3.93,0,0,1-.76-.67c-.47-.46-1.11-1.15-1.86-2a43.59,43.59,0,0,1-8.55-15.94c-.32-1.12-.55-2-.66-2.68A3.25,3.25,0,0,1,239.76,398.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.89,152.44A32.53,32.53,0,0,0,74,196.37c-3-19.5-10.47-38-32.07-43.93",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.83,142.88a8.3,8.3,0,0,1,.47,1.49c.26,1,.67,2.36,1.22,4.07A80.62,80.62,0,0,0,46,161.3,79.8,79.8,0,0,0,53.68,173c1.12,1.4,2,2.52,2.71,3.27a10.87,10.87,0,0,1,1,1.21,8.47,8.47,0,0,1-1.14-1.07c-.71-.72-1.69-1.8-2.84-3.18a69.45,69.45,0,0,1-13.23-24.67c-.51-1.72-.87-3.14-1.07-4.12A11.2,11.2,0,0,1,38.83,142.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.68,351.48a21,21,0,0,0,3.39,34.95c4.75-11.81,6.67-24.56-3.39-34.95",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.12,345.16c.08,0-.33,1.41-.82,3.66a51.69,51.69,0,0,0-.75,17.94c.3,2.29.6,3.7.51,3.72a4.34,4.34,0,0,1-.31-1c-.17-.63-.37-1.55-.57-2.69a44,44,0,0,1,.76-18.08c.29-1.13.57-2,.79-2.64A4.32,4.32,0,0,1,77.12,345.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.26,98.62a21,21,0,0,0,30.33-17.68c-12.72.61-25.1,4.2-30.33,17.68",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.91,100c0-.08,1.42-.28,3.67-.78a51.86,51.86,0,0,0,16.61-6.81c2-1.24,3.11-2.09,3.16-2a3.47,3.47,0,0,1-.74.69c-.5.42-1.26,1-2.22,1.64a43.77,43.77,0,0,1-16.73,6.87c-1.15.21-2.08.33-2.73.39A3.81,3.81,0,0,1,254.91,100Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.34,96.81a27.69,27.69,0,0,0,16.72-43.17c-12.6,11.09-22.42,25-16.72,43.17",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.89,103.39a6.94,6.94,0,0,1,.84-1c.57-.63,1.38-1.57,2.34-2.75a67,67,0,0,0,11.53-20.7c.5-1.44.87-2.62,1.11-3.44a6.57,6.57,0,0,1,.43-1.26,5.94,5.94,0,0,1-.24,1.31c-.17.84-.5,2-1,3.5a58.67,58.67,0,0,1-11.59,20.82c-1,1.16-1.86,2.07-2.48,2.66A6.13,6.13,0,0,1,229.89,103.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.37,439.37a12.65,12.65,0,0,0,21,2.37c-6.36-4.28-13.64-7-21-2.37",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.83,437.73a58.44,58.44,0,0,0,7.2,2.64,56.24,56.24,0,0,0,7.58,1.14,7.37,7.37,0,0,1-2.27.14,25.39,25.39,0,0,1-10.58-2.71A7.62,7.62,0,0,1,313.83,437.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.07,80.33a12.64,12.64,0,0,0,21.07-1.74c-7.07-3-14.73-4.23-21.07,1.74",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.28,79.41a38.34,38.34,0,0,0,15.23.85,7.84,7.84,0,0,1-2.2.57,25.34,25.34,0,0,1-10.91-.61A7.53,7.53,0,0,1,406.28,79.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.31,111.09a21,21,0,0,0,26.37-23.15c-12.36,3-23.82,8.93-26.37,23.15",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.33,113.61c0-.08,1.33-.55,3.45-1.47a51.84,51.84,0,0,0,15-9.86c1.69-1.59,2.65-2.65,2.72-2.59a3.85,3.85,0,0,1-.6.81c-.41.51-1,1.21-1.86,2a43.83,43.83,0,0,1-15.11,9.94c-1.08.42-2,.73-2.6.9A4.14,4.14,0,0,1,644.33,113.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674,415.88a36.55,36.55,0,0,0,21.18-57.29C678.75,373.48,666.09,392,674,415.88",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.91,424.68a12.27,12.27,0,0,1,1.12-1.36c.75-.84,1.8-2.09,3.05-3.66s2.69-3.5,4.18-5.7,3-4.71,4.47-7.41,2.67-5.36,3.7-7.82,1.84-4.71,2.45-6.63,1.07-3.48,1.36-4.57a10.33,10.33,0,0,1,.52-1.68,12.13,12.13,0,0,1-.32,1.73c-.23,1.11-.64,2.69-1.21,4.63s-1.36,4.22-2.35,6.71-2.24,5.15-3.69,7.88a86.65,86.65,0,0,1-4.53,7.43c-1.53,2.2-3,4.11-4.29,5.66s-2.4,2.77-3.19,3.57A11.09,11.09,0,0,1,666.91,424.68Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shape--inject-150"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M538.22,289.8c-6.31-35.25-36.58-66-72.27-68.94-19.45-1.58-39,4.55-58.37,2.21a68,68,0,0,1-42.49-22.4c-16-18.2-21.41-44.09-38.35-61.41-23.34-23.89-64.07-24.26-92.47-6.69s-45.57,49.28-53.43,81.73l-.31,9.87C178.82,257.83,187.68,297,207.21,327c19.79,30.4,32.8,43,68.86,64.81,30.62,18.56,90.58,26.72,126.38,27.58s72.57-9.8,99.5-33.42S544.54,325.05,538.22,289.8Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M538.22,289.8c-6.31-35.25-36.58-66-72.27-68.94-19.45-1.58-39,4.55-58.37,2.21a68,68,0,0,1-42.49-22.4c-16-18.2-21.41-44.09-38.35-61.41-23.34-23.89-64.07-24.26-92.47-6.69s-45.57,49.28-53.43,81.73l-.31,9.87C178.82,257.83,187.68,297,207.21,327c19.79,30.4,32.8,43,68.86,64.81,30.62,18.56,90.58,26.72,126.38,27.58s72.57-9.8,99.5-33.42S544.54,325.05,538.22,289.8Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 556.22,
    cy: 413.16,
    r: 17.25,
    transform: "translate(67.46 904.27) rotate(-81.74)",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 556.22,
    cy: 413.16,
    r: 17.25,
    transform: "translate(67.46 904.27) rotate(-81.74)",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--error-404--inject-150"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M435.16,280.45q.49,51.66-22.52,79t-63,27.7q-40.2.39-63.91-26.48t-24.22-78.52l-.58-60.56q-.5-51.46,22.52-79t63.21-27.88q40-.39,63.73,26.67t24.21,78.51Zm-44.83-66.92Q390,181,379,165.49t-32-15.32q-20.93.2-31.59,15.93T305,214.35l.7,73.59q.31,32.7,11.47,48.31t32.07,15.41q20.91-.2,31.49-15.93T391,287.12Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M435.16,280.45q.49,51.66-22.52,79t-63,27.7q-40.2.39-63.91-26.48t-24.22-78.52l-.58-60.56q-.5-51.46,22.52-79t63.21-27.88q40-.39,63.73,26.67t24.21,78.51Zm-44.83-66.92Q390,181,379,165.49t-32-15.32q-20.93.2-31.59,15.93T305,214.35l.7,73.59q.31,32.7,11.47,48.31t32.07,15.41q20.91-.2,31.49-15.93T391,287.12Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M460.62,280.21q.5,51.65-22.52,79t-63,27.7q-40.2.39-63.91-26.49T287,281.88l-.58-60.56q-.5-51.46,22.52-79t63.21-27.89q40-.37,63.73,26.67T460,219.65Zm-44.83-66.92q-.32-32.52-11.38-48t-32-15.32q-20.93.21-31.59,15.93t-10.36,48.26l.71,73.58q.32,32.71,11.47,48.32t32.07,15.41q20.91-.21,31.49-15.93t10.26-48.62Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.55,224.92c.05.13-5.86,2.48-13.2,5.24S260,235,260,234.91s5.86-2.48,13.2-5.24S286.5,224.78,286.55,224.92Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,248.85c.05.13-5.86,2.48-13.21,5.24s-13.33,4.88-13.38,4.75,5.86-2.48,13.2-5.24S288,248.71,288,248.85Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.49,272.78c.05.13-5.86,2.48-13.21,5.24S263,282.9,262.9,282.77s5.86-2.48,13.2-5.24S289.44,272.64,289.49,272.78Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,296.71c.05.13-5.86,2.48-13.21,5.24s-13.34,4.88-13.39,4.75,5.87-2.48,13.21-5.24S290.91,296.57,291,296.71Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.43,320.64a4.43,4.43,0,0,1-.92.45c-.6.26-1.48.62-2.56,1.05-2.18.87-5.19,2-8.53,3.29s-6.38,2.36-8.59,3.14c-1.1.39-2,.7-2.62.9a3.61,3.61,0,0,1-1,.26,4.1,4.1,0,0,1,.92-.45c.6-.26,1.47-.62,2.56-1,2.17-.87,5.19-2,8.53-3.29s6.38-2.37,8.59-3.14c1.1-.39,2-.7,2.62-.9A3.44,3.44,0,0,1,292.43,320.64Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.26,342.53a21.43,21.43,0,0,1-3,1.33c-1.9.76-4.53,1.78-7.44,2.88s-5.57,2.06-7.49,2.73a20.88,20.88,0,0,1-3.16,1,20.58,20.58,0,0,1,3-1.33c1.89-.77,4.52-1.79,7.44-2.88s5.56-2.06,7.49-2.73A19.63,19.63,0,0,1,299.26,342.53Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.89,362.61a17.39,17.39,0,0,1-2.69,1.21c-1.69.68-4,1.59-6.62,2.57s-5,1.83-6.68,2.42a17.32,17.32,0,0,1-2.82.87,16.29,16.29,0,0,1,2.69-1.21c1.68-.68,4-1.59,6.62-2.57s5-1.83,6.68-2.43A16.55,16.55,0,0,1,313.89,362.61Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.2,375.78a18.09,18.09,0,0,1-2.69,1.2c-1.69.69-4,1.6-6.62,2.57s-5,1.83-6.68,2.43a16.55,16.55,0,0,1-2.82.86,17.39,17.39,0,0,1,2.69-1.21c1.69-.68,4-1.59,6.62-2.57s5-1.83,6.68-2.42A15.47,15.47,0,0,1,338.2,375.78Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.52,324.71c.06.13-7.53,3.67-16.95,7.91s-17.11,7.56-17.17,7.43,7.53-3.67,17-7.91S411.46,324.58,411.52,324.71Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.5,304.21c.06.13-6.21,3.07-14,6.57s-14.15,6.24-14.21,6.11,6.2-3.08,14-6.58S416.44,304.08,416.5,304.21Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.79,281.18c.06.13-6.21,3.07-14,6.57s-14.15,6.24-14.21,6.11,6.2-3.08,14-6.58S418.73,281,418.79,281.18Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.08,258.14c.06.13-6.2,3.08-14,6.58s-14.15,6.23-14.21,6.1,6.21-3.07,14-6.57S421,258,421.08,258.14Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.38,235.11c.05.13-6.21,3.08-14,6.58s-14.15,6.23-14.21,6.1,6.21-3.07,14-6.58S423.32,235,423.38,235.11Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.79,214.6c.06.13-6.21,3.08-14,6.58s-14.15,6.23-14.21,6.1,6.2-3.08,14-6.58S418.73,214.47,418.79,214.6Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.79,192.52c.06.13-6.21,3.08-14,6.58s-14.15,6.23-14.21,6.1,6.2-3.08,14-6.58S418.73,192.39,418.79,192.52Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.5,171.73c.06.13-6.21,3.07-14,6.57s-14.15,6.24-14.21,6.11,6.2-3.08,14-6.58S416.44,171.6,416.5,171.73Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.75,157.24a85.43,85.43,0,0,1-8.47,4.1,85.54,85.54,0,0,1-8.69,3.62,81.6,81.6,0,0,1,8.47-4.1A85.54,85.54,0,0,1,396.75,157.24Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.19,148.37a88.25,88.25,0,0,1-8.47,4.09,85.54,85.54,0,0,1-8.69,3.62A85.45,85.45,0,0,1,377.5,152,85.54,85.54,0,0,1,386.19,148.37Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.68,195.91c.05.13-5.86,2.48-13.2,5.24s-13.34,4.89-13.39,4.75,5.86-2.48,13.21-5.24S287.63,195.78,287.68,195.91Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295,166.07c.06.13-6.36,2.66-14.31,5.66s-14.46,5.3-14.51,5.17,6.36-2.67,14.32-5.66S295,165.93,295,166.07Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.27,136.53c.05.14-8.08,3.31-18.16,7.1s-18.29,6.75-18.34,6.62,8.08-3.32,18.16-7.11S314.22,136.4,314.27,136.53Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.31,325l-.42-.14-1.2-.47c-.53-.19-1.22-.34-2-.56a20.6,20.6,0,0,0-2.83-.35c-4.27-.27-10.67,1.28-16.86,5.92a47.91,47.91,0,0,0-8.93,8.83c-2.87,3.51-5.68,7.48-8.87,11.48a52.59,52.59,0,0,1-11.52,11.17,41.58,41.58,0,0,1-15.94,6.46,41,41,0,0,1-17.19-.57,81.31,81.31,0,0,1-15.06-5.59c-4.65-2.15-9-4.34-13.14-6.15A69.79,69.79,0,0,0,330.41,351a44.05,44.05,0,0,0-10.3-1.18,30.87,30.87,0,0,0-7.75,1.05,28.23,28.23,0,0,0-4.62,1.81l-1.14.6a2,2,0,0,1-.4.19l.37-.23,1.12-.65a25.61,25.61,0,0,1,4.61-1.91,30.74,30.74,0,0,1,7.8-1.15,43.89,43.89,0,0,1,10.39,1.11,70,70,0,0,1,12,4c4.18,1.8,8.53,4,13.17,6.12a80.74,80.74,0,0,0,15,5.52,40.45,40.45,0,0,0,17,.56,41.27,41.27,0,0,0,15.75-6.37,52.13,52.13,0,0,0,11.44-11.05c3.19-4,6-7.94,8.91-11.46a48.18,48.18,0,0,1,9-8.85c6.28-4.64,12.77-6.16,17.09-5.82a20.63,20.63,0,0,1,2.86.39c.8.25,1.49.41,2,.62l1.19.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.62,258.3c0,.05-.71.14-1.95.55a19.44,19.44,0,0,0-4.83,2.59c-1.9,1.33-4,3.19-6.41,5.11a45.74,45.74,0,0,1-8.59,5.29,47.23,47.23,0,0,1-17.66,4.56c-1.17.1-2.24.07-3.17.09s-1.73-.06-2.38-.11l-1.51-.15a1.63,1.63,0,0,1-.51-.09,1.89,1.89,0,0,1,.52,0l1.51.05,2.37,0c.93-.05,2,0,3.14-.16a49.37,49.37,0,0,0,17.47-4.67,47.88,47.88,0,0,0,8.52-5.2c2.43-1.88,4.54-3.73,6.5-5a18,18,0,0,1,5-2.48,11.71,11.71,0,0,1,1.48-.32A1.64,1.64,0,0,1,462.62,258.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332,281.47a2.71,2.71,0,0,1-.54-.08c-.36-.08-.89-.16-1.56-.35a23.38,23.38,0,0,1-5.36-2.35,54.22,54.22,0,0,1-7-5.11c-2.51-2.08-5.19-4.45-8.26-6.57a28.31,28.31,0,0,0-9.49-4.35,29.29,29.29,0,0,0-14.24.06c-1.33.34-2.05.6-2.06.55a1.85,1.85,0,0,1,.5-.23c.34-.13.84-.33,1.51-.52a26,26,0,0,1,5.75-1,28,28,0,0,1,8.65.71,28.39,28.39,0,0,1,9.67,4.39c3.11,2.15,5.79,4.54,8.28,6.63a57.31,57.31,0,0,0,6.88,5.17,26,26,0,0,0,5.23,2.47A20,20,0,0,1,332,281.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.17,186.94a10.55,10.55,0,0,1-1.67.61,20.07,20.07,0,0,1-2,.59c-.79.2-1.68.47-2.69.65s-2.1.43-3.3.58-2.47.29-3.82.41a58.06,58.06,0,0,1-8.8-.11,58.77,58.77,0,0,1-8.67-1.53c-1.3-.37-2.55-.71-3.68-1.12s-2.19-.79-3.13-1.18-1.78-.8-2.52-1.14-1.35-.67-1.85-.95a11.57,11.57,0,0,1-1.52-.91,12.19,12.19,0,0,1,1.61.73c.51.25,1.14.56,1.88.87s1.58.71,2.54,1.05,2,.77,3.13,1.12,2.36.71,3.66,1.06a57,57,0,0,0,17.32,1.63c1.34-.11,2.61-.18,3.8-.36s2.28-.33,3.28-.51,1.89-.4,2.68-.57,1.47-.35,2-.5A12.55,12.55,0,0,1,332.17,186.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.94,186.69a2.1,2.1,0,0,1-.42-.21l-1.16-.67a19.68,19.68,0,0,0-1.86-1,26.55,26.55,0,0,0-2.53-1.19l-1.5-.63c-.53-.21-1.09-.37-1.67-.57-1.14-.42-2.41-.71-3.74-1.06a41.39,41.39,0,0,0-17.68-.15,37.92,37.92,0,0,0-3.76,1c-.58.19-1.15.34-1.68.54l-1.51.6a27.52,27.52,0,0,0-2.55,1.15,16.51,16.51,0,0,0-1.87,1l-1.18.65c-.27.14-.42.21-.43.19a1.8,1.8,0,0,1,.38-.28l1.12-.74a15.93,15.93,0,0,1,1.85-1.06,23.32,23.32,0,0,1,2.54-1.23l1.51-.64c.53-.21,1.11-.37,1.69-.57a35.7,35.7,0,0,1,3.79-1.05,40.12,40.12,0,0,1,17.89.16c1.34.36,2.62.67,3.77,1.11.58.21,1.15.38,1.67.61l1.51.66a28,28,0,0,1,2.52,1.27,16.33,16.33,0,0,1,1.82,1.1l1.12.76C456.83,186.57,457,186.67,456.94,186.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.8,118.76a4.3,4.3,0,0,1-.72.44L393,120.35c-1.85,1-4.53,2.39-7.89,4.07-6.7,3.31-16.11,7.84-27.25,10.66a74.66,74.66,0,0,1-16,2.22,57.39,57.39,0,0,1-13.13-1.13,45.58,45.58,0,0,1-8.5-2.59c-1-.38-1.69-.78-2.19-1a5.76,5.76,0,0,1-.75-.39,3.87,3.87,0,0,1,.79.3c.52.19,1.24.56,2.23.91a49.13,49.13,0,0,0,8.49,2.42,58.41,58.41,0,0,0,13.05,1,75.66,75.66,0,0,0,15.87-2.25c11.07-2.8,20.49-7.25,27.22-10.48l8-3.93L395,119.1A6.66,6.66,0,0,1,395.8,118.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.06,293l33.43,1.46-1.55,35.43-33.43-1.46-2.57,58.87-44-1.92,2.57-58.87L36,321.55l.09-27,121-173.8,45.42,2Zm-115-5,71,3.1,4.68-107.38-1.07-.41-4,7.65Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M195.06,293l33.43,1.46-1.55,35.43-33.43-1.46-2.57,58.87-44-1.92,2.57-58.87L36,321.55l.09-27,121-173.8,45.42,2Zm-115-5,71,3.1,4.68-107.38-1.07-.41-4,7.65Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M223,294.22l33.43,1.46-1.55,35.43-33.43-1.46-2.57,58.87-44-1.92,2.57-58.87-113.56-5,.09-27L185,122l45.43,2Zm-115-5,71.05,3.1,4.68-107.38-1.07-.41-4,7.65Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.59,300.92a5.51,5.51,0,0,1-1.08.61c-.71.36-1.75.86-3,1.46-2.57,1.21-6.16,2.82-10.17,4.52s-7.66,3.14-10.32,4.15c-1.33.5-2.42.89-3.17,1.15a6.3,6.3,0,0,1-1.19.36,5.4,5.4,0,0,1,1.12-.55l3.1-1.31L50.1,307l10.22-4.37,3.11-1.32A6,6,0,0,1,64.59,300.92Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.87,271a12.43,12.43,0,0,1-1.51.79c-1,.48-2.42,1.16-4.2,2-3.57,1.62-8.52,3.79-14,6.12S50.61,284.23,47,285.65c-1.82.72-3.3,1.28-4.34,1.65a9.12,9.12,0,0,1-1.62.52,12.2,12.2,0,0,1,1.55-.71l4.27-1.8,14.11-5.93,14.08-6,4.27-1.81A8.85,8.85,0,0,1,80.87,271Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.74,244.27a10.48,10.48,0,0,1-1.58.8c-1,.48-2.53,1.16-4.39,2-3.73,1.63-8.9,3.8-14.64,6.13s-11,4.36-14.79,5.79c-1.9.71-3.45,1.27-4.52,1.64a9.72,9.72,0,0,1-1.69.52,13.59,13.59,0,0,1,1.62-.71l4.46-1.8,14.72-5.93,14.69-6,4.46-1.81A11.49,11.49,0,0,1,100.74,244.27Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.33,275.11a5.69,5.69,0,0,1-1.09.59c-.71.35-1.75.83-3.05,1.41-2.58,1.17-6.18,2.72-10.19,4.35s-7.68,3-10.34,4c-1.34.48-2.42.86-3.17,1.11a6.54,6.54,0,0,1-1.19.33,5.22,5.22,0,0,1,1.11-.52l3.12-1.26L165.81,281l10.24-4.2,3.11-1.27A5.66,5.66,0,0,1,180.33,275.11Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.09,330.05a5.41,5.41,0,0,1-1.05.59c-.69.34-1.7.83-2.95,1.41-2.5,1.17-6,2.72-9.87,4.34s-7.45,3-10,4c-1.3.48-2.35.86-3.08,1.1a5.51,5.51,0,0,1-1.16.34,5.35,5.35,0,0,1,1.08-.53l3-1.26,10-4.11,9.92-4.2,3-1.26A5.67,5.67,0,0,1,177.09,330.05Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.63,349.31a5.14,5.14,0,0,1-1,.58c-.69.35-1.7.83-3,1.42-2.5,1.16-6,2.71-9.88,4.34s-7.44,3-10,4c-1.29.48-2.34.86-3.08,1.11a4.58,4.58,0,0,1-1.15.33,6.14,6.14,0,0,1,1.08-.52l3-1.26,10-4.11,9.93-4.2,3-1.26A4.77,4.77,0,0,1,176.63,349.31Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.17,368.56a5.86,5.86,0,0,1-1,.59c-.69.35-1.7.83-3,1.41-2.51,1.17-6,2.72-9.88,4.34s-7.44,3-10,4c-1.29.48-2.35.86-3.08,1.1a5.74,5.74,0,0,1-1.15.34,5.27,5.27,0,0,1,1.08-.53l3-1.25,10-4.12,9.93-4.2,3-1.26A5.38,5.38,0,0,1,176.17,368.56Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.85,254.77a6.48,6.48,0,0,1-1.09.59c-.71.35-1.75.83-3,1.41-2.58,1.17-6.18,2.72-10.19,4.35s-7.68,3-10.34,4c-1.34.48-2.42.86-3.17,1.1a6.21,6.21,0,0,1-1.19.34,4.88,4.88,0,0,1,1.11-.53l3.12-1.26,10.28-4.11,10.24-4.2,3.11-1.26A5.66,5.66,0,0,1,180.85,254.77Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.37,234.43a6.48,6.48,0,0,1-1.09.59c-.71.34-1.75.83-3.05,1.41-2.58,1.17-6.18,2.72-10.19,4.34s-7.67,3-10.34,4c-1.34.48-2.42.85-3.17,1.1a6.21,6.21,0,0,1-1.19.34,4.85,4.85,0,0,1,1.12-.53l3.11-1.26,10.28-4.11,10.24-4.2,3.11-1.26A5.66,5.66,0,0,1,181.37,234.43Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.89,214.09a5.73,5.73,0,0,1-1,.56c-.67.33-1.66.79-2.89,1.35-2.47,1.12-5.89,2.61-9.71,4.15s-7.32,2.87-9.86,3.78c-1.27.45-2.3.81-3,1a5.31,5.31,0,0,1-1.14.32,5.14,5.14,0,0,1,1.07-.51l3-1.2,9.79-3.91,9.76-4,3-1.2A4.61,4.61,0,0,1,181.89,214.09Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.19,195.08a29.12,29.12,0,0,1-5,2.13,28.82,28.82,0,0,1-5.19,1.65,29.24,29.24,0,0,1,5-2.14A28.23,28.23,0,0,1,184.19,195.08Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.57,216.59a12.75,12.75,0,0,1-1.57.8c-1,.48-2.53,1.15-4.4,2-3.72,1.63-8.89,3.8-14.64,6.13s-11,4.37-14.78,5.79c-1.9.71-3.45,1.27-4.52,1.64a13.06,13.06,0,0,1-1.69.53,10.33,10.33,0,0,1,1.62-.72l4.46-1.79L99.77,225l14.69-6,4.45-1.81A13.28,13.28,0,0,1,120.57,216.59Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.41,188.9a10.48,10.48,0,0,1-1.58.8c-1,.48-2.53,1.16-4.39,2-3.72,1.62-8.9,3.8-14.64,6.12s-11,4.37-14.78,5.79c-1.91.72-3.45,1.28-4.53,1.65a10.12,10.12,0,0,1-1.68.52,12,12,0,0,1,1.61-.71l4.46-1.8,14.72-5.93,14.7-6,4.45-1.82A12,12,0,0,1,140.41,188.9Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.74,161.22a12.53,12.53,0,0,1-1.58.8c-1,.48-2.53,1.15-4.39,2-3.72,1.63-8.9,3.8-14.64,6.13s-11,4.37-14.78,5.79c-1.9.71-3.45,1.27-4.52,1.64a13.06,13.06,0,0,1-1.69.53,10.33,10.33,0,0,1,1.62-.72l4.46-1.79,14.72-5.93,14.69-6,4.45-1.81A10.1,10.1,0,0,1,158.74,161.22Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.82,134.6a13.55,13.55,0,0,1-1.58.8c-1,.48-2.53,1.15-4.39,2-3.73,1.63-8.9,3.8-14.64,6.13s-11,4.37-14.79,5.79c-1.9.71-3.44,1.27-4.52,1.64a12,12,0,0,1-1.69.53,10.94,10.94,0,0,1,1.62-.72l4.46-1.79L157,143l14.69-6,4.46-1.81A12,12,0,0,1,177.82,134.6Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.44,175.27a3.8,3.8,0,0,1-.58.66,19.78,19.78,0,0,1-1.81,1.75,31.77,31.77,0,0,1-7.77,5,34.22,34.22,0,0,1-13.36,3,31.29,31.29,0,0,1-8.09-.91,41,41,0,0,1-8.17-3.05c-5.38-2.62-10.16-5.71-14.83-7.86a34,34,0,0,0-13.1-3.42,19.42,19.42,0,0,0-8.93,1.67,15.49,15.49,0,0,0-2.17,1.24,6.15,6.15,0,0,1-.74.47,6.16,6.16,0,0,1,.68-.55,14,14,0,0,1,2.14-1.34,19.19,19.19,0,0,1,9-1.86A33.9,33.9,0,0,1,174,173.48c4.72,2.15,9.52,5.23,14.85,7.83a41.44,41.44,0,0,0,8.08,3,31.09,31.09,0,0,0,7.95.92,33.65,33.65,0,0,0,21-7.73c.85-.68,1.45-1.28,1.87-1.67A5.64,5.64,0,0,1,228.44,175.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.52,125.83a9.27,9.27,0,0,1-1.27.74c-.83.45-2.07,1-3.63,1.7a54,54,0,0,1-5.6,2,56.76,56.76,0,0,1-14.34,2.34,53.2,53.2,0,0,1-6-.12c-1.69-.13-3-.29-4-.46a8.44,8.44,0,0,1-1.44-.29,7.68,7.68,0,0,1,1.47.09c.93.11,2.29.21,4,.29s3.69.1,5.91,0a67.89,67.89,0,0,0,7.18-.74,69.23,69.23,0,0,0,7-1.58c2.13-.62,4-1.26,5.59-1.88s2.82-1.15,3.68-1.54A8.14,8.14,0,0,1,214.52,125.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.52,236.89a7.42,7.42,0,0,1-.9-1l-2.36-2.82a112.47,112.47,0,0,0-8.38-8.75,30.65,30.65,0,0,0-5.25-4,15.94,15.94,0,0,0-5-1.94,14.07,14.07,0,0,0-4.95,0s.11-.06.33-.13a5.5,5.5,0,0,1,1-.23,11.2,11.2,0,0,1,3.71,0,15.52,15.52,0,0,1,5.17,1.89,29.14,29.14,0,0,1,5.37,4.07,87.5,87.5,0,0,1,8.3,8.9c1,1.21,1.74,2.22,2.24,2.92A6.14,6.14,0,0,1,143.52,236.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.29,267.1s-.13.12-.39.3-.65.47-1.19.77A29.6,29.6,0,0,1,217,270.4a30.6,30.6,0,0,1-32-6.55,28.06,28.06,0,0,1-3.44-3.89c-.37-.49-.61-.9-.79-1.17s-.26-.42-.24-.43a17.49,17.49,0,0,1,1.19,1.48,34.09,34.09,0,0,0,3.53,3.74,31.15,31.15,0,0,0,31.59,6.47,32.72,32.72,0,0,0,4.71-2.06A17.89,17.89,0,0,1,223.29,267.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.42,330.42s-.1-.15-.28-.47-.46-.78-.8-1.38a38.37,38.37,0,0,0-3.42-5.07l-1.36-1.6-.73-.87-.85-.83-1.8-1.78-2.1-1.74a47.28,47.28,0,0,0-11-6.53,45.12,45.12,0,0,0-15-3.49,41.78,41.78,0,0,0-17.43,2.8c-5.85,2.3-11.5,5.77-17.48,9.13a82.88,82.88,0,0,1-9.39,4.66A38.33,38.33,0,0,1,160.31,326a33.78,33.78,0,0,1-10.78-.65A48.23,48.23,0,0,1,139.6,322a104,104,0,0,1-16.92-10.28c-5.13-3.65-10-7.18-14.81-10a53.29,53.29,0,0,0-14.23-6.08,36.49,36.49,0,0,0-12.71-.84,27.11,27.11,0,0,0-9.23,2.67,23.32,23.32,0,0,0-5,3.45L65.54,302c-.25.25-.39.37-.39.37s.11-.14.36-.41l1.09-1.17a22.88,22.88,0,0,1,5-3.55,27.07,27.07,0,0,1,9.3-2.78,36.55,36.55,0,0,1,12.83.77,54.12,54.12,0,0,1,14.36,6.06c4.87,2.82,9.73,6.34,14.87,10a103.75,103.75,0,0,0,16.85,10.2,47.38,47.38,0,0,0,9.82,3.35,33.46,33.46,0,0,0,10.63.64,38,38,0,0,0,10.31-2.7,85.34,85.34,0,0,0,9.34-4.62c6-3.35,11.64-6.83,17.54-9.14a37.89,37.89,0,0,1,4.46-1.44c.75-.19,1.49-.42,2.23-.57l2.24-.37a42.78,42.78,0,0,1,8.7-.4,45.48,45.48,0,0,1,15.17,3.58,47.86,47.86,0,0,1,11,6.64c.72.61,1.42,1.21,2.1,1.77l1.79,1.81.84.84c.25.3.5.59.73.88.48.57.93,1.11,1.35,1.63a35.47,35.47,0,0,1,3.35,5.14q.49.92.75,1.41C252.35,330.25,252.42,330.42,252.42,330.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.2,372.19a2,2,0,0,1-.51.13l-1.48.28a23.13,23.13,0,0,1-2.35.35c-.92.09-2,.24-3.14.27l-1.84.08c-.63,0-1.3,0-2,0-1.37,0-2.84-.13-4.38-.25a60.47,60.47,0,0,1-9.87-1.92,61.27,61.27,0,0,1-9.36-3.68c-1.36-.73-2.67-1.4-3.83-2.15-.58-.36-1.16-.69-1.69-1l-1.5-1.05c-1-.65-1.77-1.34-2.5-1.92a22,22,0,0,1-1.81-1.55c-.43-.42-.8-.76-1.09-1a2.14,2.14,0,0,1-.36-.39,2.27,2.27,0,0,1,.43.31l1.16,1c.49.42,1.1.93,1.85,1.47s1.55,1.22,2.53,1.85l1.51,1c.53.35,1.11.67,1.69,1,1.16.73,2.47,1.38,3.83,2.09a57.13,57.13,0,0,0,19.06,5.55c1.53.13,3,.29,4.35.3.68,0,1.34.06,2,0l1.82,0c1.16,0,2.21-.13,3.13-.19s1.71-.16,2.35-.26l1.49-.18A1.79,1.79,0,0,1,222.2,372.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.32,293.41l33.3-3.25,3.45,35.29-33.3,3.26,5.73,58.64-43.8,4.29L589,333,475.84,344.06l-3.71-26.73,95.35-189.09,45.25-4.43ZM514.74,304.62l70.77-6.92-10.46-107-1.12-.25-2.86,8.14Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M629.32,293.41l33.3-3.25,3.45,35.29-33.3,3.26,5.73,58.64-43.8,4.29L589,333,475.84,344.06l-3.71-26.73,95.35-189.09,45.25-4.43ZM514.74,304.62l70.77-6.92-10.46-107-1.12-.25-2.86,8.14Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M657.17,290.69l33.3-3.26,3.46,35.3L660.62,326l5.74,58.65-43.81,4.28-5.73-58.64L503.69,341.33,500,314.61l95.35-189.09,45.25-4.43ZM542.6,301.89,613.37,295,602.91,188l-1.13-.26-2.85,8.14Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.26,319.61a6,6,0,0,1-1,.75c-.65.46-1.61,1.1-2.8,1.88-2.39,1.56-5.71,3.66-9.44,5.9s-7.14,4.19-9.64,5.56c-1.24.68-2.26,1.23-3,1.59a6.08,6.08,0,0,1-1.13.52,5.07,5.07,0,0,1,1-.7l2.89-1.73,9.56-5.69,9.5-5.76,2.89-1.74A5.62,5.62,0,0,1,501.26,319.61Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.16,287.67a10.93,10.93,0,0,1-1.38,1c-.9.61-2.23,1.48-3.88,2.54-3.3,2.11-7.9,5-13,8s-9.8,5.81-13.21,7.73c-1.7,1-3.09,1.73-4.06,2.24a11.91,11.91,0,0,1-1.53.75,10.54,10.54,0,0,1,1.43-.93l4-2.38,13.13-7.85,13.09-7.91,4-2.39A10.67,10.67,0,0,1,513.16,287.67Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.08,258.44a11.4,11.4,0,0,1-1.45,1c-1,.62-2.34,1.5-4.07,2.57-3.46,2.13-8.28,5-13.64,8.12S499.67,276,496.1,278c-1.78,1-3.23,1.75-4.24,2.27a11.7,11.7,0,0,1-1.6.75,11.74,11.74,0,0,1,1.5-.93l4.16-2.41,13.74-7.94,13.71-8,4.15-2.42A11.76,11.76,0,0,1,529.08,258.44Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.22,277.78a5.66,5.66,0,0,1-1,.73c-.65.45-1.62,1.07-2.81,1.83-2.4,1.52-5.74,3.56-9.48,5.74s-7.18,4.06-9.69,5.38c-1.25.67-2.27,1.19-3,1.54a5.78,5.78,0,0,1-1.13.5,5.71,5.71,0,0,1,1-.68l2.91-1.68,9.59-5.52,9.55-5.59,2.91-1.69A5.59,5.59,0,0,1,612.22,277.78Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.74,332.62a5.12,5.12,0,0,1-1,.73c-.63.44-1.56,1.06-2.72,1.82-2.31,1.5-5.54,3.53-9.16,5.69s-6.95,4-9.38,5.34c-1.21.66-2.2,1.18-2.89,1.53a5,5,0,0,1-1.1.49,5.72,5.72,0,0,1,1-.67l2.81-1.67,9.29-5.47,9.24-5.56,2.81-1.67A5.13,5.13,0,0,1,616.74,332.62Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619,351.75a5.12,5.12,0,0,1-1,.73c-.63.44-1.56,1.06-2.72,1.82-2.31,1.5-5.54,3.53-9.16,5.68s-6.95,4-9.38,5.35c-1.21.66-2.2,1.18-2.89,1.53a5,5,0,0,1-1.1.49,5.72,5.72,0,0,1,1-.67l2.81-1.67,9.29-5.47,9.24-5.56,2.81-1.67A5.13,5.13,0,0,1,619,351.75Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.24,370.88a5.12,5.12,0,0,1-1,.73c-.63.44-1.56,1.06-2.72,1.81-2.31,1.51-5.54,3.54-9.16,5.69s-6.95,4-9.38,5.35c-1.21.66-2.2,1.18-2.89,1.53a5.75,5.75,0,0,1-1.1.49,5.72,5.72,0,0,1,1-.67l2.81-1.67,9.29-5.47,9.24-5.56,2.81-1.67A5.13,5.13,0,0,1,621.24,370.88Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.87,257.56a6.09,6.09,0,0,1-1,.74c-.66.44-1.62,1.07-2.82,1.83-2.4,1.51-5.74,3.56-9.48,5.73s-7.18,4.06-9.68,5.39c-1.26.66-2.28,1.19-3,1.54a5.78,5.78,0,0,1-1.13.5,6.12,6.12,0,0,1,1-.68l2.9-1.68,9.6-5.52,9.55-5.6,2.9-1.68A6.13,6.13,0,0,1,609.87,257.56Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.52,237.35a5.54,5.54,0,0,1-1,.74c-.66.44-1.62,1.06-2.82,1.82-2.39,1.52-5.73,3.57-9.48,5.74s-7.17,4.06-9.68,5.39c-1.25.66-2.27,1.19-3,1.54a4.9,4.9,0,0,1-1.13.49,5.43,5.43,0,0,1,1-.67l2.9-1.69,9.6-5.51,9.55-5.6,2.9-1.69A6.32,6.32,0,0,1,607.52,237.35Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.18,217.14a5.11,5.11,0,0,1-.94.7c-.63.43-1.55,1-2.69,1.75-2.27,1.45-5.45,3.4-9,5.47s-6.84,3.87-9.23,5.13l-2.85,1.46a5.37,5.37,0,0,1-1.08.47,5.93,5.93,0,0,1,1-.65l2.76-1.61,9.15-5.25,9.09-5.34,2.77-1.6A5.19,5.19,0,0,1,605.18,217.14Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.78,198a28.31,28.31,0,0,1-4.66,2.82,30,30,0,0,1-4.91,2.37,28.31,28.31,0,0,1,4.66-2.82A29.62,29.62,0,0,1,604.78,198Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.82,228.24a10.71,10.71,0,0,1-1.44,1c-1,.62-2.35,1.5-4.08,2.57-3.45,2.13-8.27,5-13.63,8.12s-10.25,5.87-13.82,7.81c-1.78,1-3.24,1.75-4.25,2.27a12.79,12.79,0,0,1-1.59.75,10.85,10.85,0,0,1,1.5-.93l4.16-2.41,13.74-7.94,13.7-8,4.16-2.42A12.15,12.15,0,0,1,544.82,228.24Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.57,198a11.4,11.4,0,0,1-1.45,1c-1,.62-2.34,1.5-4.07,2.57-3.46,2.13-8.28,5-13.63,8.12s-10.26,5.87-13.83,7.81c-1.78,1-3.23,1.75-4.24,2.27a11.7,11.7,0,0,1-1.6.75,11.74,11.74,0,0,1,1.5-.93l4.16-2.41,13.74-7.94,13.71-8,4.16-2.42A11.38,11.38,0,0,1,560.57,198Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.83,168.05a11.4,11.4,0,0,1-1.45,1c-1,.62-2.34,1.5-4.07,2.57-3.46,2.13-8.28,5-13.64,8.12s-10.25,5.87-13.82,7.81c-1.78,1-3.23,1.75-4.24,2.27a12.41,12.41,0,0,1-1.6.75,11.74,11.74,0,0,1,1.5-.93l4.16-2.41,13.74-7.94,13.71-8,4.15-2.42A11.06,11.06,0,0,1,574.83,168.05Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590,139a11.4,11.4,0,0,1-1.45,1c-.95.62-2.34,1.5-4.07,2.57-3.46,2.13-8.28,5-13.64,8.13s-10.25,5.86-13.82,7.81c-1.78,1-3.23,1.74-4.24,2.26a11.87,11.87,0,0,1-1.6.76,9.86,9.86,0,0,1,1.5-.94l4.16-2.4,13.74-8,13.71-8,4.15-2.42A11.76,11.76,0,0,1,590,139Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.81,172.16a4.85,4.85,0,0,1-.48.73,19.44,19.44,0,0,1-1.55,2,31.58,31.58,0,0,1-7,6.06,34.08,34.08,0,0,1-12.8,4.9,31.3,31.3,0,0,1-8.13.23,41.1,41.1,0,0,1-8.52-1.87c-5.7-1.83-10.86-4.22-15.79-5.7A34.15,34.15,0,0,0,578.1,177a19.52,19.52,0,0,0-8.61,2.91,16.8,16.8,0,0,0-2,1.53,4.52,4.52,0,0,1-.66.57,5,5,0,0,1,.59-.64,14.06,14.06,0,0,1,1.93-1.63,19.17,19.17,0,0,1,8.68-3.1A33.9,33.9,0,0,1,591.69,178c5,1.47,10.16,3.84,15.8,5.67a41.93,41.93,0,0,0,8.42,1.86,31.31,31.31,0,0,0,8-.21,34.11,34.11,0,0,0,12.67-4.73,33.17,33.17,0,0,0,7-5.88,23.22,23.22,0,0,0,1.61-1.92A6.22,6.22,0,0,1,645.81,172.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.07,125.17a8.08,8.08,0,0,1-1.15.91c-.76.57-1.9,1.32-3.35,2.19a54,54,0,0,1-5.26,2.77,62.86,62.86,0,0,1-6.8,2.61,62,62,0,0,1-7.08,1.73,57.2,57.2,0,0,1-5.9.72c-1.69.11-3.06.13-4,.1a7.14,7.14,0,0,1-1.47-.09,7.81,7.81,0,0,1,1.46-.11c.94,0,2.3-.12,4-.27s3.66-.42,5.84-.82a71,71,0,0,0,7-1.75,67.62,67.62,0,0,0,6.76-2.56c2-.91,3.81-1.81,5.27-2.65s2.63-1.53,3.42-2A8.51,8.51,0,0,1,625.07,125.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.4,245.11a7.52,7.52,0,0,1-1-.88l-2.74-2.45a112.18,112.18,0,0,0-9.52-7.49,30.52,30.52,0,0,0-5.77-3.26,15.86,15.86,0,0,0-5.22-1.21,14.2,14.2,0,0,0-4.91.66s.1-.08.31-.18a6.5,6.5,0,0,1,.94-.36,11.16,11.16,0,0,1,3.68-.49,15.58,15.58,0,0,1,5.38,1.14,29.11,29.11,0,0,1,5.88,3.27,88,88,0,0,1,9.48,7.65c1.14,1.06,2,2,2.63,2.58A5.88,5.88,0,0,1,570.4,245.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.62,263.81s-.1.13-.34.35-.58.55-1.07.92a28.17,28.17,0,0,1-4.33,2.87,30.65,30.65,0,0,1-32.57-2,28,28,0,0,1-3.94-3.37c-.44-.43-.74-.8-1-1a1.71,1.71,0,0,1-.3-.4s.5.46,1.39,1.3a33.11,33.11,0,0,0,4,3.21,31.13,31.13,0,0,0,32.18,2,33.31,33.31,0,0,0,4.38-2.7A17.72,17.72,0,0,1,653.62,263.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.38,322.39A4.5,4.5,0,0,1,691,322c-.24-.29-.56-.71-1-1.25a39.27,39.27,0,0,0-4.1-4.54l-1.58-1.4-.84-.75-1-.71-2-1.5-2.33-1.43a47.18,47.18,0,0,0-11.78-4.92A45.25,45.25,0,0,0,651,304.12a41.82,41.82,0,0,0-16.86,5.23c-5.47,3.1-10.57,7.33-16,11.5a84.91,84.91,0,0,1-8.64,5.93,38.36,38.36,0,0,1-10,4.19,34.19,34.19,0,0,1-10.77.87,48.1,48.1,0,0,1-10.31-2,103,103,0,0,1-18.19-7.79c-5.6-2.9-10.89-5.7-16.07-7.81a53.85,53.85,0,0,0-15-4,36.51,36.51,0,0,0-12.7,1,27.08,27.08,0,0,0-8.76,3.94,24.15,24.15,0,0,0-4.5,4.12l-.95,1.28c-.22.29-.34.43-.34.43s.09-.16.29-.46l.92-1.31a22.61,22.61,0,0,1,4.46-4.22,26.68,26.68,0,0,1,8.81-4.06,36.51,36.51,0,0,1,12.81-1.05,54,54,0,0,1,15.07,4c5.22,2.1,10.53,4.9,16.13,7.78a104,104,0,0,0,18.11,7.74,48,48,0,0,0,10.2,1.93,33.41,33.41,0,0,0,10.61-.86,37.93,37.93,0,0,0,9.83-4.13,82.89,82.89,0,0,0,8.59-5.89c5.44-4.15,10.57-8.39,16.09-11.51a38.1,38.1,0,0,1,4.22-2.05c.71-.3,1.4-.62,2.12-.88l2.16-.68a43.28,43.28,0,0,1,8.56-1.63,45.64,45.64,0,0,1,15.52,1.42,47.18,47.18,0,0,1,11.84,5l2.33,1.45,2,1.54,1,.71.84.77,1.57,1.42a37.67,37.67,0,0,1,4,4.62c.4.56.72,1,.94,1.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.32,368a2.67,2.67,0,0,1-.48.2l-1.42.49a23.69,23.69,0,0,1-2.28.67c-.91.22-1.92.52-3.08.71l-1.8.34c-.63.11-1.29.17-2,.26-1.36.2-2.83.27-4.38.37a61.67,61.67,0,0,1-10-.51,59.67,59.67,0,0,1-9.78-2.34c-1.46-.52-2.85-1-4.1-1.58-.63-.28-1.25-.52-1.82-.8l-1.63-.83c-1.06-.51-1.95-1.08-2.75-1.55a22.34,22.34,0,0,1-2-1.28l-1.23-.87a2.08,2.08,0,0,1-.41-.33,1.9,1.9,0,0,1,.47.24l1.28.79c.54.35,1.22.77,2,1.2s1.7,1,2.76,1.47l1.64.79c.57.28,1.19.51,1.82.78,1.25.55,2.63,1,4.08,1.52A62.14,62.14,0,0,0,642,370a63,63,0,0,0,9.95.55c1.53-.09,3-.13,4.34-.32.67-.08,1.33-.13,2-.23l1.8-.3c1.15-.16,2.16-.44,3.07-.63s1.67-.4,2.29-.59l1.45-.39A2,2,0,0,1,667.32,368Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.08,221.54l-7-1.1-43.37-14-25.36-7.33a27.32,27.32,0,0,0-21.95,1.5c-12,6.1-45.06,36.88-45.06,36.88l23.81,24.55-11.21,49.68c12.55,35.68,37.12,39.77,37.12,39.77a87,87,0,0,0,35.2-5.82C424.07,337,448,316.59,451,307.82c1.8-5.26,3.29-16.32,4.47-28.81l36.12-14.72,9.79-50Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.32,310s-.11.12-.35.31-.59.48-1.08.8a24.7,24.7,0,0,1-4.34,2.33,26.52,26.52,0,0,1-30-6.54,25,25,0,0,1-3-3.94c-.31-.49-.5-.9-.65-1.17a2.1,2.1,0,0,1-.19-.42,14.51,14.51,0,0,1,1,1.48,28,28,0,0,0,3.08,3.79,26.79,26.79,0,0,0,29.55,6.46,27.93,27.93,0,0,0,4.37-2.17C405.77,310.3,406.29,309.94,406.32,310Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.6,208.51a.75.75,0,0,1,.08.24c.05.19.11.42.18.71.15.62.36,1.55.61,2.74a66.75,66.75,0,0,1,1.43,10.23,32.31,32.31,0,0,1-.41,7.14,23.23,23.23,0,0,1-2.85,7.71,30.5,30.5,0,0,1-5.93,6.87c-2.35,2.1-4.95,4-7.6,6.06-5.64,4.23-11.12,8.06-16,11.54s-9.23,6.59-12.69,9.21l-.11.09-.11-.09a74.8,74.8,0,0,1-6.94-6.25,17.12,17.12,0,0,1-1.63-1.92c-.17-.23-.27-.42-.35-.54a1.75,1.75,0,0,1-.11-.2s.19.24.54.68a23,23,0,0,0,1.68,1.85,88.17,88.17,0,0,0,7,6.11h-.22c3.44-2.66,7.74-5.83,12.64-9.32s10.36-7.34,16-11.57c2.64-2,5.24-3.95,7.57-6a30.22,30.22,0,0,0,5.86-6.74,22.56,22.56,0,0,0,2.83-7.53,32.33,32.33,0,0,0,.47-7.06,72.64,72.64,0,0,0-1.26-10.2c-.22-1.17-.39-2.09-.52-2.76q-.08-.43-.12-.72A.77.77,0,0,1,392.6,208.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.93,231c10.15-8.71,13.59-24.38,8-36.53L574.63,193A20.39,20.39,0,0,0,585,172.44a27.31,27.31,0,0,1-31.23,5.75c-6.68-3.3-12.1-9.45-19.44-10.74-6.66-1.17-13.21,2-19.59,4.22s-14.1,3.51-19.38-.72c-4.18-3.35-5.48-9.22-5.21-14.58s1.82-10.58,2.15-15.93a36.19,36.19,0,0,0-11.59-28.22,27.46,27.46,0,0,0-43.11-13.71c-3.13,2.42-5.77,5.55-9.32,7.3-4,2-8.67,2-13,3s-8.9,3.94-9.36,8.39l-1.75,9.11c-.29.65-.6,1.29-1,1.92-3.68,6.46-11.22,10.71-12.87,18-.92,4.07.22,8.48-1.15,12.42-1.81,5.19-7.41,8.11-10,12.94-3.58,6.64-1.15,18.27,4.58,23.17s17.54,10.1,24.92,11.67c2-7.67,3.77-15.87,5.48-24.26,3,2.89,6.17,5.64,9.31,8.37,8.21,7.14,16.6,14.39,22.3,23.66,10.83,17.63,11,41,24.65,56.54,2.67,3.05,5.92,5.76,9.8,6.94s8.48.55,11.35-2.31c3.39-3.38,3.83-9.08,7.58-12.05,5-3.95,12.26-.8,17.61,2.63,3.88,2.48,7.76,5.1,12.15,6.46s9.51,1.27,13.25-1.41,5.38-8.4,2.68-12.13c-1.08-1.49-2.69-2.53-3.76-4s-1.38-3.87.09-5,3.88,0,5.63,1a33.53,33.53,0,0,0,48.74-18.13A27.79,27.79,0,0,1,580.93,231Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572,152.55a10.91,10.91,0,0,1,1.29,1.1,15,15,0,0,1,3,3.89,11.31,11.31,0,0,1,1.1,3.37,8,8,0,0,1-3.56,7.91,5.92,5.92,0,0,1-2.52.91,5.77,5.77,0,0,1-2.8-.4c-3.71-1.52-5.58-5.81-9.59-7.72-3.91-2.07-8.91-2.21-13.71-1.11s-9.49,3.71-14.22,6.37-9.76,5.51-15.55,6.5a21.83,21.83,0,0,1-8.6-.06,16.42,16.42,0,0,1-4-1.48,15.54,15.54,0,0,1-3.36-2.48,18.94,18.94,0,0,1-4.3-6.82A30.76,30.76,0,0,1,493.4,155c-.53-5-.11-9.8-.06-14.23a41.85,41.85,0,0,0-1.21-12.22,28.19,28.19,0,0,0-1.91-5,29,29,0,0,0-2.43-4.13,31.15,31.15,0,0,0-5.11-5.7,32.49,32.49,0,0,0-3.91-2.88l-1.09-.65-.36-.23a2.2,2.2,0,0,1,.39.19l1.12.6a29.78,29.78,0,0,1,9.2,8.51,29.87,29.87,0,0,1,4.45,9.2,41.55,41.55,0,0,1,1.29,12.32c0,4.46-.43,9.22.11,14.17a30.5,30.5,0,0,0,1.75,7.4,18.46,18.46,0,0,0,4.2,6.63,14.72,14.72,0,0,0,3.24,2.4,16.63,16.63,0,0,0,3.85,1.43,21.58,21.58,0,0,0,8.4.05c5.68-1,10.66-3.79,15.39-6.44s9.4-5.26,14.36-6.39a25.1,25.1,0,0,1,7.33-.62,19.26,19.26,0,0,1,3.49.57,15.87,15.87,0,0,1,3.2,1.25c4.15,2,6,6.34,9.53,7.75a5.33,5.33,0,0,0,5-.44,7.68,7.68,0,0,0,3-3.56,7.54,7.54,0,0,0,.5-4,10.81,10.81,0,0,0-1-3.31,15.71,15.71,0,0,0-2.84-3.91c-.39-.4-.7-.69-.91-.88S572,152.55,572,152.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.55,210.27s0-.15-.08-.45a7.79,7.79,0,0,0-.27-1.31,11.1,11.1,0,0,0-2.45-4.46,19.15,19.15,0,0,0-6.63-4.61c-2.9-1.33-6.5-2-10.44-2.72s-8.41-1.58-12.43-4.26a18.45,18.45,0,0,1-2.94-28.11c4.14-4.25,10-6.36,14.78-10.09a18.69,18.69,0,0,0,3.14-3.21,13.27,13.27,0,0,0,1.92-4c.8-2.84.73-5.81,1-8.7a19.75,19.75,0,0,1,.8-4.27,10.72,10.72,0,0,1,2.11-3.74,15,15,0,0,1,7.15-4c2.57-.75,5.13-1.22,7.54-1.88a20.54,20.54,0,0,0,6.59-3,24.74,24.74,0,0,0,4.93-4.62A55.05,55.05,0,0,0,427,111.9c2.21-3.34,4.1-6.47,6.11-9a29.29,29.29,0,0,1,5.83-5.76,16.27,16.27,0,0,1,4.61-2.36,9.89,9.89,0,0,1,1.75-.44s-.61.14-1.72.54a16.61,16.61,0,0,0-4.52,2.43,29.16,29.16,0,0,0-5.72,5.77c-2,2.5-3.84,5.62-6,9a52.69,52.69,0,0,1-3.72,5.11,25.35,25.35,0,0,1-5,4.72,21,21,0,0,1-6.7,3c-2.44.68-5,1.15-7.53,1.9a14.44,14.44,0,0,0-6.92,3.85,10.24,10.24,0,0,0-2,3.56,19.11,19.11,0,0,0-.77,4.16c-.27,2.86-.19,5.85-1,8.8a13.56,13.56,0,0,1-2,4.12,19.08,19.08,0,0,1-3.24,3.3,66.66,66.66,0,0,1-7.69,4.89,33.58,33.58,0,0,0-7,5.15,18,18,0,0,0,2.82,27.4c3.9,2.63,8.34,3.47,12.25,4.26s7.56,1.44,10.48,2.81a19.12,19.12,0,0,1,6.67,4.74,11,11,0,0,1,2.4,4.57,7.15,7.15,0,0,1,.22,1.33C408.55,210.12,408.55,210.27,408.55,210.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.39,120.5a2.49,2.49,0,0,1-.76-.2,16.7,16.7,0,0,1-2-.8,26.43,26.43,0,0,1-10.69-9.19,17.91,17.91,0,0,1-1.09-1.86,2.42,2.42,0,0,1-.31-.73c.07,0,.64.92,1.7,2.37a30.74,30.74,0,0,0,10.55,9.08C487.38,120,488.43,120.42,488.39,120.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.64,188.71s-.63-.16-1.76-.4a28.66,28.66,0,0,0-4.86-.6,64.74,64.74,0,0,0-7.26.21c-2.74.19-5.76.47-8.95.4a24.31,24.31,0,0,1-8.83-1.66,15.75,15.75,0,0,1-5.92-4.32,11.07,11.07,0,0,1-2.27-4.39,7.58,7.58,0,0,1-.21-1.33,1.67,1.67,0,0,1,0-.47c.06,0,.09.64.41,1.75a11.6,11.6,0,0,0,2.37,4.2,15.57,15.57,0,0,0,5.82,4.12,24.53,24.53,0,0,0,8.65,1.58c3.15.07,6.16-.19,8.91-.36a57.09,57.09,0,0,1,7.31-.1,25.31,25.31,0,0,1,4.89.77,13.3,13.3,0,0,1,1.28.41A1.46,1.46,0,0,1,521.64,188.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.57,234.18s-.09,0-.29.13a4.18,4.18,0,0,1-.89.29,7.11,7.11,0,0,1-3.58-.16,11.54,11.54,0,0,1-4.8-3,20.06,20.06,0,0,1-3.86-6.47c-1.09-2.56-2-5.5-3.79-8.22a21.59,21.59,0,0,0-3.17-3.87,25.38,25.38,0,0,0-4.24-3.21c-6.28-3.79-14.53-5.34-23-4.84s-16.44,2.1-23.81,2.61a46.9,46.9,0,0,1-19.4-2,26.87,26.87,0,0,1-11.13-7,16.46,16.46,0,0,1-1.33-1.59,9.48,9.48,0,0,1-.86-1.25c-.2-.33-.36-.6-.49-.8a1.21,1.21,0,0,1-.15-.28s.08.08.2.25l.52.77a12,12,0,0,0,.9,1.21,15.86,15.86,0,0,0,1.36,1.55,27.11,27.11,0,0,0,11.09,6.76,47.2,47.2,0,0,0,19.25,1.88c7.33-.54,15.29-2.22,23.82-2.66s16.85,1.07,23.23,4.95a25.81,25.81,0,0,1,4.31,3.29,22.15,22.15,0,0,1,3.22,4c1.81,2.79,2.7,5.76,3.77,8.31a19.7,19.7,0,0,0,3.72,6.41,11.39,11.39,0,0,0,4.65,3,7,7,0,0,0,3.5.25C580.17,234.35,580.56,234.14,580.57,234.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.29,120.49a7.48,7.48,0,0,0-7.62,6.65h0l-8.09,84.21c-1.4,11.84,14.09,37.23,26.78,38.63h0c12.81,1.41,14.07-4.8,15.73-16,2.78-18.74,3.71-25.8,3.7-25.69s16.5-.55,22.62-21.18c3-10.26,4.78-27.51,5.75-41.67.87-12.75-5.46-29.36-18.24-29.69Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.58,156.59a2.71,2.71,0,0,1-3,2.38,2.61,2.61,0,0,1-2.47-2.8,2.74,2.74,0,0,1,3-2.39A2.61,2.61,0,0,1,476.58,156.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.73,151.14c-.32.38-2.48-1-5.41-.79s-5,1.82-5.31,1.49c-.16-.15.13-.81,1-1.56a7.5,7.5,0,0,1,4.22-1.63,7.16,7.16,0,0,1,4.33,1.07C477.53,150.35,477.88,151,477.73,151.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.85,158.11c-.35.35-2.37-1.24-5.3-1.31s-5.12,1.33-5.43,1c-.15-.17.21-.8,1.17-1.45a7.41,7.41,0,0,1,4.36-1.21,7.18,7.18,0,0,1,4.2,1.49C450.73,157.31,451,158,450.85,158.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.31,173.6c0-.17,1.86-.24,4.84-.23.75,0,1.47,0,1.67-.53a3.81,3.81,0,0,0-.21-2.26q-.69-2.84-1.45-6c-2-8.45-3.33-15.36-3-15.44s2.23,6.72,4.22,15.17c.48,2.08.93,4.06,1.36,6a4.32,4.32,0,0,1,0,3,1.87,1.87,0,0,1-1.36.92,5.08,5.08,0,0,1-1.29,0C458.13,174,456.3,173.76,456.31,173.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.79,208.27A54,54,0,0,1,426.56,197s5.21,15.42,26.56,16.23Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.26,153.1c-.46.71-3.23-.33-6.67-.71s-6.37-.1-6.65-.9c-.12-.38.52-1,1.79-1.49a11.05,11.05,0,0,1,5.21-.56,11.19,11.19,0,0,1,4.94,1.78C451,152,451.47,152.76,451.26,153.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.29,147.21c-.48.69-2.53.11-5,.2s-4.46.67-5,0c-.22-.33.07-1,.93-1.68a6.82,6.82,0,0,1,4-1.3,6.91,6.91,0,0,1,4,1.13C477.19,146.2,477.5,146.88,477.29,147.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.23,178.91a6.26,6.26,0,0,1,4.59-1,3.57,3.57,0,0,1,2.13,1.11,4.53,4.53,0,0,1,.75,3.05,6.14,6.14,0,0,1-.29,1.91,2.5,2.5,0,0,1-1.22,1.43,3.43,3.43,0,0,1-2,.1,7.52,7.52,0,0,1-3.09-1.12,3.81,3.81,0,0,1-1.72-2.7,2.58,2.58,0,0,1,1.55-2.66",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.12,185.33c-.21.08-.6-.56-1.3-1.43a10.69,10.69,0,0,0-7.26-4.14c-1.11-.16-1.85-.17-1.9-.39s.65-.59,1.92-.72a8.37,8.37,0,0,1,4.81,1.08,8.25,8.25,0,0,1,3.37,3.59C457.3,184.47,457.31,185.27,457.12,185.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.45,205.56c6.95-1.39,12.31-7.36,14.7-14s2.26-13.95,1.63-21a3.37,3.37,0,0,0-.95-2.48c-1.05-.81-2.56-.15-3.7.54a115.48,115.48,0,0,0-12.57,8.84c-3.72,3-7.4,6.45-8.83,11-2.19,7,2.44,15.35,9.53,17.19",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.2,203.93l-32.77-52.68-9.06-18.54s-2.89-3.83-5.89-7.1c-4.92-5.37-9.79-1.2-9.79-1.2a3.32,3.32,0,0,0-3.29-2,5.59,5.59,0,0,0-4.53,2.31s-1.34-1.49-5.06-1.72a3.87,3.87,0,0,0-2.35.76c-1.22-1.07-3.46-2.61-5.61-1.83-1.68.61-11.87,8.36-14.38,12.26-1.24,1.93,1.06,4.43,4.16,3.26a27.53,27.53,0,0,0,3.72-1.51,10.17,10.17,0,0,0,2.52-2s-2.57,4.5,0,5.29a5.89,5.89,0,0,0,4.83-1.17c1-.82,2.1-1.89,3.17-2.94l-.12.18c-1.42,2.1,2.28,5.21,4.07,3.95a26.62,26.62,0,0,0,2.39-1.9c4.16,3-1.61,6.89-4.05,6.69a74.6,74.6,0,0,0-11.28,0c-2.12.17-4,.68-5.16,1.85-1.38,1.42.07,4.4,2,4.7,3.59.56,8.17,1.35,12.93,2.58,5.6,1.44,20.27,6.21,20.27,6.21l1.43,1.16,19.93,48.61-34.12,7.23-7.62,43.24,61.6-16.72C568,235.6,574.61,217.13,566.2,203.93Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.93,159.29a4.2,4.2,0,0,1-.78-.19l-2.21-.63-8.11-2.41-5.59-1.69c-2-.62-4.15-1.26-6.43-1.84a61.37,61.37,0,0,0-7.22-1.49,12.36,12.36,0,0,1-3.92-.71,2.62,2.62,0,0,1-.88-.65,1.65,1.65,0,0,1-.3-.54l-.07-.53a5.1,5.1,0,0,1,.13-2.12,2.92,2.92,0,0,1,1.42-1.64,10.46,10.46,0,0,1,1.9-.76,12.88,12.88,0,0,1,4-.49c2.6,0,5.05.4,7.39.3a23.18,23.18,0,0,0,3.39-.33c1.09-.2,2.13-.48,3.15-.74a16.86,16.86,0,0,1,5.83-.75,15.76,15.76,0,0,1,4.7,1.2,29.68,29.68,0,0,1,3.28,1.61c.87.49,1.53.9,2,1.17a5.31,5.31,0,0,1,.66.45,4.1,4.1,0,0,1-.72-.36l-2-1.08a32.23,32.23,0,0,0-3.29-1.52,15.59,15.59,0,0,0-4.62-1.1,16.57,16.57,0,0,0-5.69.79c-1,.27-2.06.57-3.17.78a22.9,22.9,0,0,1-3.47.36c-2.38.11-4.86-.24-7.4-.27a12.54,12.54,0,0,0-3.8.47c-1.22.4-2.61.83-3,2.07a4.83,4.83,0,0,0-.11,1.9l.07.46a.8.8,0,0,0,.19.33,2.36,2.36,0,0,0,.71.53,12.45,12.45,0,0,0,3.75.66,61,61,0,0,1,7.28,1.54c2.29.59,4.43,1.25,6.43,1.89l5.58,1.75,8.06,2.57,2.18.72A4.09,4.09,0,0,1,512.93,159.29Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.66,122c.06.08-1.54,1-3.9,2.79a41.13,41.13,0,0,0-3.92,3.4c-1.4,1.36-2.87,3-4.61,4.45a4.74,4.74,0,0,0-1.84,2.47,1.74,1.74,0,0,0,1.2,2.14,5.26,5.26,0,0,0,2.64.05,12.51,12.51,0,0,0,2.3-.66,16.48,16.48,0,0,0,4.05-2.46,3.91,3.91,0,0,1-.9.94,12.26,12.26,0,0,1-3,1.87,12.73,12.73,0,0,1-2.35.74,5.74,5.74,0,0,1-2.88,0,2.22,2.22,0,0,1-1.55-2.71,5.25,5.25,0,0,1,2-2.76c1.71-1.46,3.18-3,4.62-4.4a35.37,35.37,0,0,1,4-3.34c1.22-.87,2.25-1.49,3-1.91A6.77,6.77,0,0,1,487.66,122Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.17,126.12a13.75,13.75,0,0,1-1.16,1.37l-3.29,3.62-4.93,5.33a12.16,12.16,0,0,1-3.46,2.64,5.35,5.35,0,0,1-2.3.57,3.2,3.2,0,0,1-2.3-.92,2.14,2.14,0,0,1-.54-1.25,3.6,3.6,0,0,1,.13-1.28,7.29,7.29,0,0,1,1.06-2.19h0v0c1.77-1.87,3.41-3.63,4.88-5.25s2.94-2.89,4.12-4a8.29,8.29,0,0,1,1.71-1.37,4.22,4.22,0,0,1,1.61-.36c.89-.06,1.41,0,1.36.12a4.1,4.1,0,0,0-1.34.06,4.53,4.53,0,0,0-1.51.4,9.17,9.17,0,0,0-1.61,1.39c-1.14,1.14-2.55,2.46-4,4.06s-3.08,3.42-4.84,5.31l0,0a7,7,0,0,0-1,2,3.21,3.21,0,0,0-.12,1.1,1.75,1.75,0,0,0,.42.95,2.71,2.71,0,0,0,1.92.75,4.83,4.83,0,0,0,2.07-.51,11.82,11.82,0,0,0,3.33-2.51l5-5.25,3.41-3.5.95-.94Q500.14,126.1,500.17,126.12Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.49,130.94s0,.31-.4.59A2.12,2.12,0,0,1,512,131c-.23-.38-.23-.67-.17-.68s.2.19.46.45a2.34,2.34,0,0,0,1.22.66,2.38,2.38,0,0,0,1.38-.21C515.23,131.06,515.43,130.89,515.49,130.94Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.69,135.53c-.11.09-.86-.66-1.52-1.79a4.16,4.16,0,0,1-.83-2.19c.13-.05.63.85,1.28,1.93A7.81,7.81,0,0,1,516.69,135.53Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.9,153.41a6.46,6.46,0,0,1-.95-2.08,17,17,0,0,1-.82-5.47,17.15,17.15,0,0,1,1-5.44,6.41,6.41,0,0,1,1-2.06,26.61,26.61,0,0,0-1.45,7.51A26.34,26.34,0,0,0,518.9,153.41Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.82,222.7c-.1,0-.2-1.06-.72-2.69a16.81,16.81,0,0,0-1.18-2.75,16.67,16.67,0,0,0-4.8-5.45,16.29,16.29,0,0,0-2.57-1.53c-1.54-.73-2.59-1-2.57-1.06a2.21,2.21,0,0,1,.75.1,11.61,11.61,0,0,1,2,.62,14.79,14.79,0,0,1,2.7,1.48,15.41,15.41,0,0,1,4.94,5.62,14.28,14.28,0,0,1,1.11,2.87,11.24,11.24,0,0,1,.37,2A2.48,2.48,0,0,1,545.82,222.7Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.44,319a14.23,14.23,0,0,0-8.33,1.06c-4.45-2-9.94,1.43-9.94,1.43-1.61-.77-11.31,5.57-11.31,5.57l-12.08,5.7-64.53-47.95,18.29-19-25.63-26.67-30,30.9a22.65,22.65,0,0,0-6,14.55,29.59,29.59,0,0,0,16.43,28l76,39a88.75,88.75,0,0,0,17.29-2.69c6.56-1.71,17.77-6.69,17.77-6.69s0,.34,2,4.23c3.61,7,8.9-.56,8.9-.56a14.51,14.51,0,0,0,2.06,3.42c4.57,4.43,7.74-1.52,7.74-1.52s1.37,2.39,5.45.61-.59-14.06-.59-14.06,1.37,2.67,4-.71S435.81,319.92,431.44,319Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.31,320.69a1.93,1.93,0,0,1,.84-.33,5,5,0,0,1,2.45.08,9.35,9.35,0,0,1,3.23,1.65,12.42,12.42,0,0,1,1.61,1.43,9.94,9.94,0,0,1,1.26,2,48.6,48.6,0,0,1,2.95,7.41c.3,1,.5,1.77.63,2.33a2.63,2.63,0,0,1,.13.88c-.07,0-.43-1.19-1.11-3.1a68.39,68.39,0,0,0-3.07-7.29,8.86,8.86,0,0,0-1.18-1.85,13.09,13.09,0,0,0-1.51-1.39,9.91,9.91,0,0,0-3-1.68A6.69,6.69,0,0,0,422.31,320.69Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.08,347.81a5.65,5.65,0,0,1-.57-1.11l-1.41-3.06c-1.19-2.59-2.93-6.13-4.59-10.16a27,27,0,0,0-2.63-5.47,9,9,0,0,0-3.71-3.09,6,6,0,0,0-3.2-.57c-.78.1-1.18.31-1.2.26s.09-.07.28-.17a3.19,3.19,0,0,1,.88-.29,5.87,5.87,0,0,1,3.39.43,9.17,9.17,0,0,1,3.95,3.16,26,26,0,0,1,2.72,5.54c1.65,4,3.34,7.58,4.45,10.21.55,1.31,1,2.39,1.26,3.13A5.72,5.72,0,0,1,430.08,347.81Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.46,332.38a5.67,5.67,0,0,1,1-.57l2.88-1.39c.62-.29,1.27-.61,2-.93a5.66,5.66,0,0,1,2.59-.38,5.39,5.39,0,0,1,2.72,1,8.53,8.53,0,0,1,2,2.36c.55.9,1,1.83,1.4,2.69s.87,1.69,1.31,2.47c.87,1.55,1.69,2.94,2.29,4.16a23.44,23.44,0,0,1,1.28,2.95,4.13,4.13,0,0,1,.32,1.13c-.08,0-.62-1.55-1.92-3.91-.65-1.18-1.49-2.54-2.39-4.09-.45-.78-.9-1.61-1.34-2.48s-.86-1.78-1.39-2.65a8.5,8.5,0,0,0-1.85-2.23,5.05,5.05,0,0,0-2.45-1,5.23,5.23,0,0,0-2.39.3c-.72.29-1.41.61-2,.86L401.57,332A4.86,4.86,0,0,1,400.46,332.38Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.86,327.07a3.86,3.86,0,0,1-.88.55c-.58.33-1.43.79-2.49,1.35-2.11,1.12-5.05,2.64-8.31,4.28s-6.22,3.1-8.38,4.14l-2.56,1.2a4,4,0,0,1-1,.37,4.36,4.36,0,0,1,.89-.56c.58-.32,1.43-.78,2.49-1.34,2.11-1.12,5.05-2.63,8.31-4.28s6.22-3.1,8.37-4.13c1.08-.52,2-.93,2.57-1.21A3.65,3.65,0,0,1,401.86,327.07Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.11,284.93a32.63,32.63,0,0,0-7.62-.25,33,33,0,0,0-7.36,2,7.1,7.1,0,0,1,2-1.12,19.12,19.12,0,0,1,5.3-1.42,19.33,19.33,0,0,1,5.5.14A7.05,7.05,0,0,1,326.11,284.93Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.62,111.71a201,201,0,0,0-47.52,5c-3.61.83-7.43,1.89-9.87,4.67-2.59,2.94-3,7.13-3.38,11q-.62,7.13-1.24,14.25a32.82,32.82,0,0,1-2.27,3.39c-3.76,4.91-8.55,9-12,14.16s-5.31,12-2.53,17.52c1.69,3.34,4.81,5.7,7.09,8.66,3.87,5,5.13,11.51,7.39,17.44s6.34,12,12.57,13.16c3,.57,6.06-.06,9.05.38,4.47.65,8.23,3.58,11.78,6.37s7.41,5.63,11.91,6.08,9.65-2.6,9.74-7.12a10.56,10.56,0,0,1-10.87-.3c-2.62-1.73-4.31-4.53-6.56-6.71-5.53-5.36-14.43-7.06-18.28-13.73-3-5.27-1.83-11.88-.45-17.81,1.19-5.14,2.41-10.71.92-15.65a17.51,17.51,0,0,0,.19-2.4c0-5.26-2.05-10.9.4-15.55,3.24-6.16,12.58-6.94,15.85-13.07,1.91-3.57,1.24-8.13,3.32-11.6,1.95-3.26,5.86-4.76,9.58-5.57s7.63-1.18,10.91-3.1S470.11,115.2,468.62,111.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.74,219a1,1,0,0,1-.15.25l-.49.69a13.9,13.9,0,0,1-2.3,2.33,15.53,15.53,0,0,1-4.57,2.45,15.79,15.79,0,0,1-6.8.79,14.37,14.37,0,0,1-7.66-3.14c-2.38-1.83-4.5-4.26-7.19-6.19a10.38,10.38,0,0,0-4.58-1.93,10,10,0,0,0-5.1.93,25.57,25.57,0,0,1-5.29,1.82,9.29,9.29,0,0,1-5.7-1,28.68,28.68,0,0,1-4.81-3.19,39.09,39.09,0,0,1-4.22-3.67,13.19,13.19,0,0,1-3-4.52,9.36,9.36,0,0,1-.34-5.2,28.27,28.27,0,0,1,1.51-4.69c.58-1.47,1.08-2.92,1.52-4.34a58.26,58.26,0,0,0,1.85-8,59.17,59.17,0,0,0,.65-11.93c-.06-1.41-.15-2.51-.23-3.25,0-.35,0-.62-.07-.84a.91.91,0,0,1,0-.29.9.9,0,0,1,.06.28l.12.84c.11.74.24,1.83.33,3.25a56.88,56.88,0,0,1-.48,12,58.87,58.87,0,0,1-1.8,8.11c-.44,1.42-.94,2.89-1.51,4.38A28.16,28.16,0,0,0,419,199.5a8.79,8.79,0,0,0,.34,4.94,12.73,12.73,0,0,0,2.9,4.34,38.46,38.46,0,0,0,4.17,3.61,28.21,28.21,0,0,0,4.72,3.13,8.74,8.74,0,0,0,5.39,1,25.42,25.42,0,0,0,5.18-1.79,10.57,10.57,0,0,1,5.35-.94,10.85,10.85,0,0,1,4.8,2c2.74,2,4.84,4.44,7.18,6.25a13.92,13.92,0,0,0,7.43,3.11,16,16,0,0,0,11.2-3A18.49,18.49,0,0,0,480.74,219Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.83,187.2a11.57,11.57,0,0,1-.8-1.11,11.31,11.31,0,0,1-1.42-3.64,15.06,15.06,0,0,1,.1-6.18,19,19,0,0,1,3.46-7.42,34.59,34.59,0,0,1,7.22-6.82c2.87-2.14,6.13-4.13,9.38-6.44a34.42,34.42,0,0,0,8.9-8.65,22.29,22.29,0,0,0,2.7-6c.64-2.14,1.08-4.38,1.6-6.64a35.3,35.3,0,0,1,2-6.58,14.86,14.86,0,0,1,3.93-5.43,16.68,16.68,0,0,1,5.67-3.13,26.29,26.29,0,0,1,6.08-1.2,69.41,69.41,0,0,1,11.4.36,52.91,52.91,0,0,0,9.86.13,21,21,0,0,0,7.73-2.3,15.32,15.32,0,0,0,4.73-3.82,11.49,11.49,0,0,0,1.92-3.35c.28-.84.39-1.3.41-1.29a9.79,9.79,0,0,1-.31,1.33,11.3,11.3,0,0,1-1.86,3.44,15.53,15.53,0,0,1-4.75,4,21.22,21.22,0,0,1-7.83,2.41,52.62,52.62,0,0,1-9.94-.07,70,70,0,0,0-11.32-.31,25.63,25.63,0,0,0-6,1.2,16.26,16.26,0,0,0-5.5,3,14.44,14.44,0,0,0-3.79,5.26,34.43,34.43,0,0,0-2,6.49c-.52,2.25-1,4.5-1.62,6.67a22.2,22.2,0,0,1-2.77,6.1,34.72,34.72,0,0,1-9,8.76c-3.28,2.32-6.54,4.29-9.4,6.4a34.21,34.21,0,0,0-7.18,6.7,18.44,18.44,0,0,0-3.47,7.25,14.76,14.76,0,0,0-.19,6.08A12.73,12.73,0,0,0,380.83,187.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.76,192.45a22.11,22.11,0,0,1-3.07-2.95,13.75,13.75,0,0,1-2.67-4.23,6.93,6.93,0,0,1-.46-3.13,6.21,6.21,0,0,1,1.35-3.27c1.62-2,4.3-3.06,7.11-3.65,1.41-.29,2.89-.52,4.36-.89a12.4,12.4,0,0,0,4.26-1.77,10.28,10.28,0,0,0,3.1-3.67,33.68,33.68,0,0,0,1.92-4.77,33.78,33.78,0,0,1,2-5,10.6,10.6,0,0,1,3.75-4.15,18.42,18.42,0,0,1,5.21-2c1.77-.46,3.52-.83,5.17-1.39a16.72,16.72,0,0,0,7.94-5.85A60.6,60.6,0,0,0,428.7,138a42.8,42.8,0,0,1,4.49-6.65,17.08,17.08,0,0,1,5.13-4.19,12.94,12.94,0,0,1,4.79-1.45,9,9,0,0,1,3.16.26,6.2,6.2,0,0,1,1,.36s-.37-.1-1.07-.26a9.81,9.81,0,0,0-3.11-.16,13.09,13.09,0,0,0-4.67,1.5,17,17,0,0,0-5,4.17,44.21,44.21,0,0,0-4.4,6.64,60.25,60.25,0,0,1-4.92,7.79,20.89,20.89,0,0,1-3.53,3.57A15.36,15.36,0,0,1,416,152c-1.68.58-3.45.95-5.2,1.41a17.75,17.75,0,0,0-5.06,2,10.11,10.11,0,0,0-3.58,4,33.32,33.32,0,0,0-2,4.93,33.44,33.44,0,0,1-2,4.83,11,11,0,0,1-3.26,3.84,13.24,13.24,0,0,1-4.43,1.82c-1.5.36-3,.58-4.38.87-2.77.56-5.38,1.59-6.91,3.45a5.88,5.88,0,0,0-1.31,3.08,6.69,6.69,0,0,0,.4,3,14.24,14.24,0,0,0,2.55,4.2c.88,1,1.63,1.79,2.14,2.3l.59.57C383.7,192.37,383.77,192.44,383.76,192.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.86,127.85a3.56,3.56,0,0,1-.52.77c-.36.48-.89,1.16-1.58,2-1.36,1.64-3.32,3.84-5.62,6.15-1.14,1.12-2.21,2.38-3.68,2.84a3.24,3.24,0,0,1-2.11,0,2.7,2.7,0,0,1-1.36-1.25,4.07,4.07,0,0,1-.37-2.54,2.38,2.38,0,0,1,.23-.9,4.29,4.29,0,0,1,0,.92,4.1,4.1,0,0,0,.49,2.34,2.31,2.31,0,0,0,1.19,1,2.75,2.75,0,0,0,1.81,0c1.28-.41,2.31-1.61,3.46-2.75,2.29-2.29,4.28-4.45,5.72-6A25.92,25.92,0,0,1,506.86,127.85Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.5,127.85a3.4,3.4,0,0,1-.61.78c-.41.48-1,1.16-1.78,2l-2.69,2.91-1.6,1.7A14.24,14.24,0,0,1,506,137a4.71,4.71,0,0,1-2.44,1,2.5,2.5,0,0,1-2.27-1,2,2,0,0,1-.37-1.16,2.29,2.29,0,0,1,.34-1.07c.37-.6.75-1.06,1.08-1.52.66-.91,1.21-1.64,1.6-2.14a3.45,3.45,0,0,1,.65-.74,4.11,4.11,0,0,1-.48.86c-.34.53-.84,1.29-1.47,2.23-.31.47-.69,1-1,1.52a1.49,1.49,0,0,0,0,1.74,2,2,0,0,0,1.85.76,4.22,4.22,0,0,0,2.16-.88,13,13,0,0,0,1.81-1.66l1.63-1.68,2.77-2.84c.79-.8,1.44-1.44,1.9-1.88A3.66,3.66,0,0,1,514.5,127.85Z",
    style: {
      fill: "#eb996e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-150"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M618.91,434a12.68,12.68,0,0,1,20.59-3.57,16.46,16.46,0,0,1-9.21,7.08A10,10,0,0,1,618.91,434",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.81,435.64a12.85,12.85,0,0,1,2.87-.9c1.81-.44,4.33-.93,7.12-1.39s5.33-.81,7.18-1a17.08,17.08,0,0,1,3-.23,17.8,17.8,0,0,1-2.94.6l-7.15,1.17c-2.78.46-5.3.9-7.12,1.24A26.52,26.52,0,0,1,611.81,435.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.48,370.69a16.66,16.66,0,0,1-3,27.69c-3.67-9.41-5.08-19.54,3-27.69",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.39,377.91A21.55,21.55,0,0,0,306.54,396c-7-11-16.47-20.27-31.15-18.11",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.52,343.13a2.82,2.82,0,0,1,.47.5l1.25,1.49c1.06,1.31,2.61,3.2,4.57,5.49,3.9,4.6,9.41,10.86,15.9,17.39,3.25,3.26,6.44,6.27,9.4,8.93s5.76,4.93,8.16,6.75a62.15,62.15,0,0,0,5.89,4c1.45.86,2.31,1.22,2.29,1.27a2.55,2.55,0,0,1-.64-.24,15.27,15.27,0,0,1-1.75-.85,53.25,53.25,0,0,1-6-3.89c-2.44-1.8-5.24-4.07-8.25-6.69s-6.2-5.66-9.46-8.92c-6.5-6.54-12-12.85-15.81-17.52-1.93-2.33-3.43-4.26-4.45-5.6l-1.18-1.56A3.62,3.62,0,0,1,243.52,343.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.71,384.91c-.09,0,.24-1.4.53-3.67a39.12,39.12,0,0,0-1.84-17.62c-.75-2.16-1.36-3.45-1.28-3.49a3.73,3.73,0,0,1,.51.86,25.87,25.87,0,0,1,1.12,2.5,34.8,34.8,0,0,1,2.1,8.78,34.41,34.41,0,0,1-.25,9A24.68,24.68,0,0,1,261,384,4.12,4.12,0,0,1,260.71,384.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702,182.54a12.67,12.67,0,0,1,6.62-19.81,16.42,16.42,0,0,1,1.87,11.45,10,10,0,0,1-8.49,8.36",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.1,189.57a12.44,12.44,0,0,1,.57-2.95c.47-1.8,1.23-4.25,2.15-6.93s1.82-5.08,2.5-6.81a16.15,16.15,0,0,1,1.22-2.75,18.11,18.11,0,0,1-.87,2.88c-.66,1.91-1.47,4.25-2.36,6.85s-1.73,5.1-2.29,6.86A29.24,29.24,0,0,1,700.1,189.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658,256.94a24.5,24.5,0,0,1,26.21-30.74c1.39,7.56-1,15.32-4.95,21.89-4.71,7.75-14.07,11-21.26,8.85",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.41,286.54a3.49,3.49,0,0,1,.43-.54l1.29-1.47c1.15-1.26,2.83-3.06,4.92-5.26,4.2-4.4,10.06-10.41,16.58-17s12.45-12.54,16.77-16.81l5.14-5.05,1.42-1.35c.32-.3.5-.46.52-.44a3.68,3.68,0,0,1-.45.52l-1.35,1.42-5,5.15L652,262.63l-16.68,16.9-5,5.14-1.36,1.4A3.14,3.14,0,0,1,628.41,286.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M658,256.94a24.5,24.5,0,0,1,26.21-30.74c1.39,7.56-1,15.32-4.95,21.89-4.71,7.75-14.07,11-21.26,8.85"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M644.29,259.91a15,15,0,0,1-3.13-24.6c4,2.5,6.56,6.77,7.89,11.29,1.58,5.34-.8,11-4.76,13.31",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M644.29,259.91a15,15,0,0,1-3.13-24.6c4,2.5,6.56,6.77,7.89,11.29,1.58,5.34-.8,11-4.76,13.31"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M645.85,268.43a3.9,3.9,0,0,1-.3-.92c-.17-.59-.36-1.46-.57-2.55-.42-2.16-.86-5.18-1.26-8.51s-.68-6.37-.85-8.57a21.67,21.67,0,0,1-.14-3.56,26.35,26.35,0,0,1,.51,3.53c.27,2.32.62,5.27,1,8.54s.78,6.34,1.1,8.51S645.93,268.41,645.85,268.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457,375.81A23.67,23.67,0,0,1,496,368.73c-11.34,8.79-24.57,14.79-38.92,7.08",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M457,375.81A23.67,23.67,0,0,1,496,368.73c-11.34,8.79-24.57,14.79-38.92,7.08"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M450.63,379.33a4.61,4.61,0,0,1,.9-.7c.6-.43,1.49-1,2.63-1.66a50,50,0,0,1,19.35-6.39c1.3-.14,2.36-.21,3.09-.22a4.19,4.19,0,0,1,1.14,0c0,.08-1.61.18-4.19.56a59.76,59.76,0,0,0-9.89,2.32,59,59,0,0,0-9.32,4C452,378.52,450.68,379.4,450.63,379.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.43,245.51a18.28,18.28,0,0,1,26,16.05c-11.05-.82-21.74-4.21-26-16.05",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M193.43,245.51a18.28,18.28,0,0,1,26,16.05c-11.05-.82-21.74-4.21-26-16.05"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M187.94,244.22a2.71,2.71,0,0,1,.88,0,23.1,23.1,0,0,1,2.37.38,38.29,38.29,0,0,1,7.54,2.41,38.85,38.85,0,0,1,6.88,3.93c.82.6,1.46,1.11,1.88,1.49a3.38,3.38,0,0,1,.63.62c-.06.07-1-.7-2.72-1.8A45.84,45.84,0,0,0,191.11,245C189.16,244.51,187.93,244.3,187.94,244.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.76,363.56a16.35,16.35,0,0,1,20.88-17.64c-3.77,9.17-9.63,17.32-20.88,17.64",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.13,367.87a11.91,11.91,0,0,1,1.25-2.66,33.64,33.64,0,0,1,9.41-10.5,12,12,0,0,1,2.51-1.53A27.35,27.35,0,0,1,560,355a41.48,41.48,0,0,0-9.32,10.39A25.49,25.49,0,0,1,549.13,367.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.45,311.61a16.35,16.35,0,0,1,17.19-21.25c-2,9.72-6.2,18.82-17.19,21.25",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M630.45,311.61a16.35,16.35,0,0,1,17.19-21.25c-2,9.72-6.2,18.82-17.19,21.25"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M628.68,316.34a11.52,11.52,0,0,1,.73-2.84,32.9,32.9,0,0,1,3-6.43,32.56,32.56,0,0,1,4.28-5.65,12,12,0,0,1,2.17-2,27.62,27.62,0,0,1-1.9,2.22,43.68,43.68,0,0,0-4.11,5.68,44.51,44.51,0,0,0-3.09,6.28A25.56,25.56,0,0,1,628.68,316.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.28,240.1a16.35,16.35,0,0,1,25.56-9.69c-6.6,7.39-14.84,13.13-25.56,9.69",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.37,243.29a12.4,12.4,0,0,1,2.06-2.09,33.38,33.38,0,0,1,5.82-4,32.68,32.68,0,0,1,6.55-2.73,11.37,11.37,0,0,1,2.87-.61,27,27,0,0,1-2.76,1,41.18,41.18,0,0,0-12.24,6.7A24.42,24.42,0,0,1,33.37,243.29Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-150"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M494.37,109.6l8-14.49a38.61,38.61,0,1,1,9.35,10.2v0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.37,109.6l17.37-4.4-.07.21,0,0-.61-.77.8.59a39.63,39.63,0,0,0,7.94,4.62,38.6,38.6,0,0,0,10.52,2.85,34.49,34.49,0,0,0,6.05.22c1-.07,2.1-.11,3.17-.21l3.21-.53a38.47,38.47,0,0,0,23.65-15.57,38.13,38.13,0,0,0,6.28-14.79A38.87,38.87,0,0,0,572,64.87a37.67,37.67,0,0,0-8.31-15.57l-1.57-1.69c-.52-.57-1.13-1-1.69-1.56a20.43,20.43,0,0,0-1.74-1.49l-1.84-1.35A15.81,15.81,0,0,0,555,42L553,40.82l-2-1a17.63,17.63,0,0,0-2-.89,38.77,38.77,0,0,0-17.09-2.47,37.45,37.45,0,0,0-15.63,4.76,38.78,38.78,0,0,0-17.94,22.4,42,42,0,0,0-1.58,12.44,38.34,38.34,0,0,0,5.8,19l0,.06,0,.07-8.15,14.42,7.93-14.55v.13a38.34,38.34,0,0,1-5.95-19.07,42,42,0,0,1,1.55-12.56A39.24,39.24,0,0,1,516,40.84,38.08,38.08,0,0,1,531.83,36a39.37,39.37,0,0,1,17.32,2.49,18,18,0,0,1,2.07.9l2.06,1,2,1.17a17.18,17.18,0,0,1,1.93,1.25L559,44.15c.64.44,1.17,1,1.77,1.51s1.18,1,1.71,1.58L564.11,49a37.91,37.91,0,0,1,8.42,15.78,39.44,39.44,0,0,1,.62,17.16,38.37,38.37,0,0,1-6.38,15,38.79,38.79,0,0,1-23.95,15.7l-3.26.53c-1.07.1-2.14.13-3.19.2a34.13,34.13,0,0,1-6.11-.25,38.45,38.45,0,0,1-10.61-2.92,39,39,0,0,1-8-4.71l.18-.18v0l.13.16-.2,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.36,68l5-.05a4.25,4.25,0,0,1,4.33-4.32,4,4,0,0,1,3.95,2.55,4.49,4.49,0,0,1-.31,4.06c-.84,1.41-2.69,2.7-6.08,2.14l.11,11.31,5,0L536.27,77a9.7,9.7,0,0,0,6.87-9.53c-.07-7.33-6.66-9-9.48-8.94C531.51,58.58,524.18,59.17,524.36,68Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 531.41,
    y: 86,
    width: 5.03,
    height: 4.7,
    transform: "translate(-0.82 5.13) rotate(-0.55)",
    style: {
      fill: "#2F55D4"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.68a4955d4f4409a4e4b0a90b1a228ff4.svg";
export { ForwardRef as ReactComponent };